export const MediaDevicesButtons = function (nid, enable_camera = true, enable_microphone = true) {
  console.log('MediaDevicesButtons Component: init', {nid, enable_camera, enable_microphone});
  if (Drupal.settings.is_broadcast_request) {
    console.warn("is broadcast request page");
    return;
  }
  const templateHTML = `
<div class="dropdown device-menu">
  <a id="microphoneButton" :title="microphone_tip" class="microphoneButton toolbarButton round-btn video-icon"
   :class="is_microphone_on ? 'microphoneOn' : 'microphoneOff'"
   @click.throttle.550ms="onMicrophoneBtnClick"
  >
    <i class="action-icon-fa fa-light" :class="'fa-microphone'+(is_microphone_on ? '':'-slash')" aria-hidden="true"></i>
  </a>
  <i class="fa-duotone fa-solid fa-message-exclamation" aria-hidden="true" x-show="microphones?.length === 0 && speakers?.length === 0"></i>
  <a x-ref="microphone-trigger" id="microphone-list-trigger" class="device-list dropdown-toggle" aria-expanded="false" x-show="microphones?.length > 0 || speakers?.length > 0">
    <i class="fa-duotone fa-circle-chevron-up fa-rotate-180" aria-hidden="true"></i>
  </a>
  <ul x-ref="microphone-list" id="microphone-list" role="menu" x-show="is_initialized">
    <li class="device-menu-title" x-show="microphones?.length > 0"><span>Select Microphone</span></li>
    <template x-for="(microphone, index) in microphones">
      <li x-bind:data-deviceid="microphone.deviceId" :class="{['dev-' + microphone.kind]: microphone.kind, 'current': microphone.deviceId === current_microphone_id}" x-on:click="onMicrophoneItemClick(microphone.deviceId)">
        <a href="javascript:void(0)" x-text="microphone.label"></a>
      </li>
    </template>
    <li class="cancelation cancelation_off" x-show="microphones?.length > 0">
      <label class="switch">
        <input type="checkbox" x-model="is_cancellation_on">
        <span class="slider"></span>
      </label>Background Noise Cancellation
    </li>
    <li class="device-menu-spt" x-show="microphones?.length > 0"></li>
    <li class="device-menu-title"><span>Select Speaker</span></li>
    <template x-for="(speaker, index) in speakers">
      <li x-bind:data-deviceid="speaker.deviceId" :class="{['dev-' + speaker.kind]: speaker.kind, 'current': speaker.deviceId === current_speaker_id}" x-on:click="onSpeakerItemClick(speaker.deviceId)">
        <a href="javascript:void(0)" x-text="speaker.label"></a>
      </li>
    </template>
  </ul>
</div>
<div class="dropdown device-menu">
  <a id="cameraButton" :title="camera_tip" class="cameraButton toolbarButton round-btn video-icon"
   :class="is_camera_on ? 'cameraOn' : 'cameraOff'"
   @click.throttle.550ms="onCameraBtnClick"
  >
    <i class="action-icon-fa fa-light" :class="'fa-video'+(is_camera_on ? '':'-slash')" aria-hidden="true"></i>
  </a>
  <i class="fa-duotone fa-solid fa-message-exclamation" aria-hidden="true" x-show="cameras?.length === 0"></i>
  <a x-ref="camera-trigger" id="camera-list-trigger" class="device-list dropdown-toggle" aria-expanded="false" x-show="cameras?.length > 0">
    <i class="fa-duotone fa-circle-chevron-up fa-rotate-180" aria-hidden="true"></i>
  </a>
  <ul x-ref="camera-list" id="camera-list" role="menu" x-show="is_initialized">
    <li class="device-menu-title"><span>Select Your Camera</span></li>
    <template x-for="(camera, index) in cameras">
      <li x-bind:data-deviceid="camera.deviceId" :class="{['dev-' + camera.kind]: camera.kind, 'current': camera.deviceId === current_camera_id}" x-on:click="onCameraItemClick(camera.deviceId)">
        <a href="javascript:void(0)" x-text="camera.label"></a>
      </li>
    </template>
    <li x-show="is_video_bg_supported" class="device-menu-title"><span>Select Background Image</span></li>
    <li x-show="is_video_bg_supported" class="vp-bg" :class="video_bg_type === 'none' && 'current'" @click="onVideoBgItemClick('none')"><a href="javascript:void(0)">None</a></li>
    <li x-show="is_video_bg_supported" class="vp-bg" :class="video_bg_type === 'blur' && 'current'" @click="onVideoBgItemClick('blur')"><a href="javascript:void(0)">Blur</a></li>
    <li x-show="is_video_bg_supported" class="vp-bg" :class="video_bg_type === 'image' && 'current'">
        <div class="video_bg_container">
        <template x-for="(item, index) in video_bg_imgs">
          <img :src="item" alt="" :class="item === video_bg_img && 'selected'" @click="onVideoBgItemClick('image', item)"/>
        </template>
        <div class="video_bg_add_btn" @click="onVideoBgAddBtnClick">+</div>
    </li>
  </ul>
</div>
`;
  const camera_not_available_msg = `Your camera is currently not available. It might be in use by another application. Close all other video-based applications and then try turning on your camera again.`
  const cancellationOptions = {
    sdkAssetsPath: '/sites/all/modules/sn_twilio/krisp/v1.0.0',
    vendor: 'krisp'
  };
  const screenshare_track_names = ['screenShare', 'video-composer-presentation', 'audio-composer-presentation'];
  const presentation_track_names = ['video-presentation-video', 'video-presentation-audio'];
  const sid = tryget(() => Toolbox.snExpoLocation.current.current_content.content_id, "") ?? "";
  const storage_prefix = `${Drupal.settings.current_user_name}_${sid}`;
  const post_video_bg_data = async function (type, url, images = []) {
    const form = new FormData();
    form.set("type", type);
    if (url) {
      form.set("img", url);
    }
    if (images?.length > 0) {
      form.set("imgs", JSON.stringify(images));
    }
    await fetch(`/twilio/video/bg?gid=${_current_expoid()}`, {method: 'POST', body: form});
  };
  const load_cancellation_models = async function () {
    // return Twilio.Video.createLocalAudioTrack({
    //   'noiseCancellationOptions': cancellationOptions
    // }).then((track) => {
    //   track.stop();
    // }).catch((e) => {
    //   console.log(e);
    // });
    return fetch(`${_base_url()}${cancellationOptions.sdkAssetsPath}/weights/model_32.kw`).catch((e) => {
      console.log(e);
    });
  };
  const get_deviceId_from_storage = function (kind, devices = []) {
    if (!kind || !devices) {
      return '';
    }
    const map = {'videoinput': '_video_dev', 'audioinput': '_audio_dev', 'audiooutput': '_speaker_dev'};
    const ids = devices.map(d => d.deviceId);
    const storage_key = localStorage.getItem(`${storage_prefix}${map[kind] ?? ''}`);
    return ids.includes(storage_key) ? storage_key : (devices[0]?.deviceId ?? '');
  };
  const check_device_permission = async function (name = '') {
    let names = ['camera', 'microphone'];
    if (names.includes(name)) {
      names = [name];
    }
    const permissions = {};
    for (const name of names) {
      try {
        permissions[name] = await navigator.permissions.query({name: name});
      } catch (e) {
        console.error(e);
      }
    }
    return permissions;
  };
  const request_device_permission = async function (constraints = {video: true, audio: true}, stop_tracks = true) {
    console.log('request_device_permission1', {constraints, stop_tracks});
    const mediaStream = await navigator.mediaDevices.getUserMedia(constraints);
    if (stop_tracks) {
      (mediaStream?.getTracks() ?? []).forEach(track => track.stop());
    }
    console.log('request_device_permission2', {
      constraints,
      stop_tracks,
      tracks: (mediaStream?.getTracks() ?? []).map(t => t.label)
    });
  };
  const show_popup = function (name, kind = 'microphone / camera') {
    let title = '';
    let clazz = '';
    let msg = '';
    if (name === 'settings') {
      title = `Permission Required`;
      clazz = 'devices_permission_settings_popup';
      msg = `
<div class="msg">Check your browser and system settings to make sure your browser has been granted permission to access the ${kind}.</div>
<img src="https://ezstack-source-1es5yaoqgtfar.s3.amazonaws.com/venue_398062/hFLUEcLgRh2NUgvi4eDS_1.png" alt="browser settings" style=" width: 100%; "/>
<ol class="list-decimal pl-5 mb-4" style="text-align: left;">
  <li>Click the lock/info icon in your browser's address bar</li>
  <li>Find the device permissions section</li>
  <li>Change the permission setting to "Allow"</li>
  <li>Refresh the page</li>
</ol>
        `;
    } else if (name === 'requesting') {
      title = 'Allow camera and microphone access';
      clazz = 'devices_permission_requesting_popup';
      msg = `
<div class="msg">Do you want people to see and hear you in the metting?</div>
<img src="https://ezstack-source-1es5yaoqgtfar.s3.amazonaws.com/venue_398062/We61aBUGTnGNywskgKUL_1.jpg" alt="permission requesting"/>
        `;
    }
    if (!['settings', 'requesting'].includes(name)) {
      return null;
    } else {
      const popup = SNModal.alert(msg, "OK", title, true, {
        backdrop: 'static',
        extra_class: ['devices_permission_popup', clazz]
      });
      popup.modal('show');
      return popup;
    }
  }

  return {
    init_devices: async function () {
      console.log('MediaDevicesButtons init_devices start');
      let devices = await navigator.mediaDevices.enumerateDevices();
      console.log('MediaDevicesButtons init_devices enumerateDevices', {devices});
      devices = devices.filter(device => device.deviceId && device.label);
      this.cameras = devices.filter(device => device.kind === 'videoinput');
      this.microphones = devices.filter(device => device.kind === 'audioinput');
      this.speakers = devices.filter(device => device.kind === 'audiooutput');
      this.current_camera_id = get_deviceId_from_storage('videoinput', this.cameras) ?? '';
      this.current_microphone_id = get_deviceId_from_storage('audioinput', this.microphones) ?? '';
      this.current_speaker_id = get_deviceId_from_storage('audiooutput', this.speakers) ?? '';
      console.log('MediaDevicesButtons init_devices done', {devices});
    },
    init: async function () {
      this.$el.innerHTML = templateHTML;
      const is_meeting_panel = this.$el.closest('.group-meeting-panel');
      console.log('MediaDevicesButtons init', {is_meeting_panel});
      if (is_meeting_panel) {
        if (is_meeting_panel.querySelector('.group-meeting-joined-wrapper .top-bar.hide')) {
          return;
        }
        try {
          await EzToolkit.RetryLib.retry(() => Promise.resolve(typeof Toolbox?.snVideoCall?.activeRoom?.localParticipant !== 'undefined'), {
            retries: 10,
            delay: 200,
            until: (v) => v
          });
        } catch (e) {
          console.log(e);
          return;
        }
      } else {
        await EzToolkit.RetryLib.retry(() => Promise.resolve(typeof Twilio?.Video?.createLocalAudioTrack === 'function'), {
          retries: "INFINITELY",
          delay: 100,
          until: (v) => v
        }).catch(e => console.error(e));
      }

      const {camera: camera_permission, microphone: microphone_permission} = await check_device_permission();
      const constraints = {
        video: camera_permission?.state === 'prompt',
        audio: microphone_permission?.state === 'prompt'
      };
      // workaround for firefox
      // see https://engagez.atlassian.net/browse/EWA-6516?focusedCommentId=25385
      if (Toolbox.util.Sys.firefox) {
        constraints.video = camera_permission?.state !== 'denied';
        constraints.audio = microphone_permission?.state !== 'denied';
      }
      console.log('MediaDevicesButtons init', {camera_permission, microphone_permission, constraints});
      if (constraints.video || constraints.audio) {
        try {
          await request_device_permission(constraints);
        } catch (e) {
          console.error(e);
        }
        console.log('MediaDevicesButtons request_device_permission2', constraints);
      }
      // workaround for firefox.
      // we don't know why, but firefox return an empty devices array if you call navigator.mediaDevices.enumerateDevices() too soon.
      // luckly, this issue only when you call in first time.
      if (Toolbox.util.Sys.firefox) {
        setTimeout(async () => {
          console.log('MediaDevicesButtons delay init_devices', constraints);
          await this.init_devices();
        }, 1800);
      } else {
        await this.init_devices();
      }
      const is_camera_on = localStorage.getItem(`${storage_prefix}_video_dev_status`) === 'on';
      const is_microphone_on = localStorage.getItem(`${storage_prefix}_audio_dev_status`) === 'on';
      this.is_cancellation_on = (localStorage.getItem(`${storage_prefix}_noise_cancellation_status`) ?? 'on') === 'on';

      this.is_video_bg_supported = (Twilio?.VideoProcessors?.isSupported ?? true) && !(navigator.platform.match(/linux/i) && Toolbox.util.Sys.firefox);
      if (this.is_video_bg_supported) {
        const bg_settings = await Toolbox.snVideoCall?.getVideoBackground();
        this.video_bg_type = bg_settings?.type ?? 'none';
        this.video_bg_imgs = (bg_settings?.images ?? []).slice(0, 5);
        this.video_bg_img = bg_settings?.image ?? '';
      }

      if (navigator.mediaDevices.ondevicechange === null) {
        navigator.mediaDevices.addEventListener('devicechange', async (e) => {
          console.log('MediaDevicesButtons ondevicechange', e);
          await this.init_devices();
        });
      }
      const on_change = async (e) => {
        console.log('MediaDevicesButtons permission change', {e, camera_permission, microphone_permission});
        await this.init_devices();
        if (camera_permission.state === 'denied') {
          this.cameras = [];
        }
        if (microphone_permission.state === 'denied') {
          this.microphones = [];
          this.speakers = [];
        }
      };
      camera_permission.onchange = on_change;
      microphone_permission.onchange = on_change;


      if (microphone_permission?.state === 'granted') {
        load_cancellation_models().then(() => {
          this.is_cancellation_modle_loaded = true;
          if (this.is_cancellation_on && this.is_microphone_on) {
            SNModal.alert('Noise cancelation will be activated next time you unmute yourself.');
          }
        }).catch((e) => {
          console.warn(e);
        });
      }

      await this.$nextTick();

      const trigger_eles = [
        [this.$refs['microphone-trigger'], this.$refs['microphone-list']],
        [this.$refs['camera-trigger'], this.$refs['camera-list']],
      ];
      for (const [trigger_ele, content_ele] of trigger_eles) {
        tippy(trigger_ele, {
          trigger: "click",
          content: content_ele,
          allowHTML: true,
          theme: 'tomato',
          interactive: true,
          placement: 'top',
          maxWidth: 'calc(80vw)',
          offset: [0, 40],
          zIndex: 9999999
        });
      }

      this.$watch('current_camera_id', (val) => {
        localStorage.setItem(`${storage_prefix}_video_dev`, val ?? '');
      });
      this.$watch('current_microphone_id', (val) => {
        localStorage.setItem(`${storage_prefix}_audio_dev`, val ?? '');
      });
      this.$watch('current_speaker_id', (val) => {
        localStorage.setItem(`${storage_prefix}_speaker_dev`, val ?? '');
      });
      this.$watch('is_camera_on', (val) => {
        localStorage.setItem(`${storage_prefix}_video_dev_status`, val ? 'on' : 'off');
      });
      this.$watch('is_microphone_on', (val) => {
        localStorage.setItem(`${storage_prefix}_audio_dev_status`, val ? 'on' : 'off');
      });
      this.$watch('is_cancellation_on', (val) => {
        localStorage.setItem(`${storage_prefix}_noise_cancellation_status`, val ? 'on' : 'off');
      });
      this.$watch('cameras', (val) => {
        if (val?.length === 0) {
          this.turnOffCamera();
        }
      });
      this.$watch('microphones', (val) => {
        if (val?.length === 0) {
          this.turnOffMicrophone();
        }
      });

      document.addEventListener('sn-change-device-status', ev => {
        console.log('sn-change-device-status', ev);
        const {device, status} = ev.detail;
        if (device === 'camera' && status === 'on' !== this.is_camera_on) {
          document.querySelector('#cameraButton').dispatchEvent(new Event('click'));
        }
        if (device === 'microphone' && status === 'on' !== this.is_microphone_on) {
          document.querySelector('#microphoneButton').dispatchEvent(new Event('click'));
        }
      });

      const wait_for_localParticipant = async () => {
        await EzToolkit.RetryLib.retry(() => Promise.resolve(Toolbox?.snVideoCall?.activeRoom?.localParticipant), {
          retries: 10,
          delay: 500,
          until: (v) => v
        }).catch(e => console.error(e));
      }
      setTimeout(async () => {
        await this.$nextTick();
        if (is_camera_on) {
          console.log('MediaDevicesButtons is_camera_on, turn on camera');
          await wait_for_localParticipant();
          this.$el.querySelector('#cameraButton').dispatchEvent(new Event('click'));
        }
        if (is_microphone_on) {
          console.log('MediaDevicesButtons is_microphone_on, turn on microphone');
          await wait_for_localParticipant();
          this.$el.querySelector('#microphoneButton').dispatchEvent(new Event('click'));
        }
      }, 100);
      this.is_initialized = true;
      console.log('MediaDevicesButtons init done', {
        is_microphone_on: is_microphone_on,
        is_camera_on: is_camera_on,
        is_cancellation_on: this.is_cancellation_on,
        current_microphone_id: this.current_microphone_id,
        current_camera_id: this.current_camera_id,
        current_speaker_id: this.current_speaker_id,
        bg_type: this.video_bg_type,
      });
    },
    destroy: function () {
      console.log('MediaDevicesButtons destroy');
    },
    is_initialized: false,
    is_camera_processing: false,
    is_microphone_processing: false,
    is_camera_on: false,
    is_microphone_on: false,
    is_cancellation_modle_loaded: false,
    is_cancellation_on: false,
    cameras: [],
    microphones: [],
    speakers: [],
    current_camera_id: '',
    current_microphone_id: '',
    current_speaker_id: '',

    is_video_bg_supported: true,
    video_bg_imgs: [],
    video_bg_type: 'none',
    video_bg_img: '',

    get camera_tip() {
      if (this.cameras?.length === 0) {
        return 'You must allow camera access in your browser settings. Click for instructions.';
      }
      return this.is_camera_on ? 'Turn off Camera' : 'Turn on Camera';
    },
    get microphone_tip() {
      if (this.microphones?.length === 0) {
        return 'You must allow microphone access in your browser settings in order to unmute. Click for instructions.';
      }
      return this.is_microphone_on ? 'Mute Microphone' : 'Unmute Microphone';
    },

    createLocalVideoTrack: async function (deviceId, bg_type = '') {
      const videoTrackOptions = {
        width: {min: 640, ideal: 1280}, height: {min: 480, ideal: 720}
      };
      if (deviceId) {
        videoTrackOptions['deviceId'] = {exact: deviceId};
      }
      let track = null;
      try {
        track = await Twilio.Video.createLocalVideoTrack(videoTrackOptions);
      } catch (e) {
        console.error(e);
        throw e;
      }
      if (track === null) {
        return null;
      }
      if (bg_type) {
        await Toolbox.snVideoCall.setVideoBackgroundProcessor(bg_type, 'vpbg-img', false, track);
      }
      return track;
    },
    publishTrack: async function (track) {
      const localParticipant = Toolbox.snVideoCall.activeRoom.localParticipant;
      return await localParticipant.publishTrack(track, {priority: 'standard'});
    },
    turnOffCamera: function (change_button_state = true) {
      const localParticipant = Toolbox.snVideoCall.activeRoom.localParticipant;
      try {
        const track = Toolbox.snVideoCall._localVideoTrack;
        console.log('turnOffCamera', {localParticipant, track});
        if (track) {
          track.stop()
          // track.detach().forEach(ele => {
          //   ele.remove();
          // });
          Toolbox.snVideoCall._localVideoTrack = null;
          localParticipant.unpublishTrack(track);
          if (change_button_state) {
            this.is_camera_on = false;
          }
        }
      } catch (e) {
        console.error(e);
      }
    },
    turnOnCamera: async function (deviceId, bg_type = '', change_button_state = true) {
      const track = await this.createLocalVideoTrack(deviceId, '');
      console.log('turnOnCamera', {track, bg_type});
      if (track === null) {
        return;
      }
      Toolbox.snVideoCall._localVideoTrack = track;
      const pub = await this.publishTrack(track);
      if (pub !== null) {
        if (change_button_state) {
          this.is_camera_on = true;
        }
        if (bg_type) {
          await Toolbox.snVideoCall.setVideoBackgroundProcessor(bg_type, 'vpbg-img');
        }
      }
      return pub;
    },
    turnOffMicrophone: function (change_button_state = true) {
      const localParticipant = Toolbox.snVideoCall.activeRoom.localParticipant;
      const tracks = Array.from(localParticipant.audioTracks.values()).map(x => x.track).filter(x => !screenshare_track_names.includes(x.name) && !presentation_track_names.includes(x.name));
      if (tracks && tracks.length > 0) {
        tracks.forEach((track) => track.stop());
        localParticipant.unpublishTracks(tracks);
      }
      if (change_button_state) {
        this.is_microphone_on = false;
      }
    },
    turnOnMicrophone: async function (deviceId, isNoiseCancellationOn = true, change_button_state = true) {
      const audioTrackOptions = {};
      if (isNoiseCancellationOn && this.is_cancellation_modle_loaded) {
        audioTrackOptions['noiseCancellationOptions'] = cancellationOptions;
      }
      if (deviceId) {
        audioTrackOptions['deviceId'] = {exact: deviceId};
      }
      const localParticipant = Toolbox.snVideoCall.activeRoom.localParticipant;
      const track = await Twilio.Video.createLocalAudioTrack(audioTrackOptions);
      const noiseCancellation = track.noiseCancellation;
      if (noiseCancellation) {
        if (isNoiseCancellationOn) {
          noiseCancellation.enable();
        } else {
          noiseCancellation.disable();
        }
      }
      const pub = localParticipant.publishTrack(track);
      if (change_button_state) {
        this.is_microphone_on = true;
      }
      return pub;
    },
    updateSpeakerDevice: function (deviceId) {
      try {
        document.querySelectorAll('.participant audio').forEach(x => {
          x.setSinkId(deviceId);
          x.play();
        });
      } catch (e) {
        console.error(e);
      }
    },

    onCameraItemClick: async function (deviceId) {
      tippy.hideAll({duration: 0});
      console.log('onCameraItemClick', {deviceId, is_camera_on: this.is_camera_on, video_bg_type: this.video_bg_type});
      let is_switch_track_success = true;
      if (this.is_camera_on) {
        try {
          this.turnOffCamera(false);
          await this.turnOnCamera(deviceId, this.video_bg_type, false);
        } catch (e) {
          console.error(e);
          SNModal.alert(camera_not_available_msg);
          is_switch_track_success = false;
        }
      }
      if (is_switch_track_success) {
        this.current_camera_id = deviceId;
      }
    },
    onMicrophoneItemClick: async function (deviceId) {
      tippy.hideAll({duration: 0});
      console.log('onMicrophoneItemClick', {deviceId});
      if (this.is_microphone_on) {
        this.turnOffMicrophone(false);
        await this.turnOnMicrophone(deviceId, this.is_cancellation_on, false);
      }
      this.current_microphone_id = deviceId;
    },
    onSpeakerItemClick: function (deviceId) {
      console.log('onSpeakerItemClick', {deviceId});
      tippy.hideAll({duration: 0});
      this.current_speaker_id = deviceId;
      this.updateSpeakerDevice(deviceId);
    },
    onVideoBgItemClick: async function (type, url = '') {
      console.log('onVideoBgItemClick', {type, img_urls: this.video_bg_imgs, img_url: this.video_bg_img});
      tippy.hideAll({duration: 0});
      this.video_bg_type = type;
      this.video_bg_img = url;
      await post_video_bg_data(type, url);
      await Toolbox.snVideoCall.setVideoBackgroundProcessor(type, 'vpbg-img', false);
    },
    onVideoBgAddBtnClick: async function () {
      console.log('onVideoBgAddBtnClick', {img_urls: this.video_bg_imgs, img_url: this.video_bg_img});
      await Toolbox.util.showFileUploadPicker({maxFiles: 1}, async (file) => {
        console.log('onVideoBgAddBtnClick showFileUploadPicker', {file});
        const {url} = file;
        if (url) {
          this.video_bg_imgs = [url, ...this.video_bg_imgs].slice(0, 5);
          this.video_bg_img = url;
          this.video_bg_type = 'image';
          await post_video_bg_data('image', url, this.video_bg_imgs);
          await Toolbox.snVideoCall.setVideoBackgroundProcessor('image', 'vpbg-img', false);
        }
      });
    },
    prepareDeviceBtnClick: async function (kind) {
      let is_continue = true;
      if (!['camera', 'microphone'].includes(kind)) {
        return is_continue;
      }

      let {[kind]: {state}} = await check_device_permission(kind);
      console.log(`onButtonClick1`, kind, {permission: state});
      // we still need to request permission (call getUserMedia) at least once(means no cameras) even if we have permission 'granted' in Firefox
      let error = '';
      if (state === 'prompt' || (state !== 'denied' && Toolbox.util.Sys.firefox)) {
        const constraints = {video: kind === 'camera', audio: kind === 'microphone'};
        if (Toolbox.util.Sys.firefox) {
          if (kind === 'camera' && this.current_camera_id) {
            constraints.video = {
              deviceId: {exact: this.current_camera_id}
            }
          }
          if (kind === 'microphone' && this.current_microphone_id) {
            constraints.audio = {
              deviceId: {exact: this.current_microphone_id}
            }
          }
        }
        try {
          await request_device_permission(constraints);
        } catch (e) {
          error = e.name;
          if (error === 'NotAllowedError' && e.message.includes('Permission dismissed')) {
            error = 'PermissionDismissed';
          }
          if (error === 'AbortError' && e.message.includes('videoinput failed')) {
            error = 'NotReadableError';
          }
          console.error(e, error, {name: e.name, msg: e.message});
        }
        if (error === '') {
          // wait for init_devices done which trigger by permission change.
          await new Promise(resolve => setTimeout(resolve, 500));
          await this.$nextTick();
        } else if (error === 'NotAllowedError') {
          state = 'denied';
        }
      }

      // init_devices may not be done in time in Firefox, we have to do it again
      let is_no_devices = ((kind === 'camera' && this.cameras?.length === 0)
        || (kind === 'microphone' && this.microphones?.length === 0));
      if (is_no_devices && error === '' && state !== 'denied' && Toolbox.util.Sys.firefox) {
        await this.init_devices();
        await this.$nextTick();
      }

      // check again after init_devices and $nextTick
      is_no_devices = ((kind === 'camera' && this.cameras?.length === 0)
        || (kind === 'microphone' && this.microphones?.length === 0));
      console.log(`onButtonClick2`, kind, {
        permission: {state},
        cameras: Alpine.raw(this.cameras),
        microphones: Alpine.raw(this.microphones)
      });
      if (is_no_devices || state === 'denied') {
        if (error !== 'PermissionDismissed' && error !== 'NotReadableError') {
          show_popup('settings', kind);
        }
        // if (state === 'denied') {
        //   if (kind === 'camera') {
        //     this.cameras = [];
        //   }
        //   if (kind === 'microphone') {
        //     this.microphones = [];
        //   }
        //   await this.$nextTick();
        // }

        is_continue = error === 'NotReadableError';
      }
      return is_continue;
    },
    onCameraBtnClick: async function () {
      if (!this.is_initialized || this.is_camera_processing) {
        return;
      }

      if (!this.is_camera_on) {
        const is_continue = await this.prepareDeviceBtnClick('camera');
        if (!is_continue) {
          return;
        }
      }

      this.is_camera_processing = true;

      try {
        if (this.is_camera_on) {
          this.turnOffCamera();
        } else {
          await this.turnOnCamera(this.current_camera_id, this.video_bg_type);
        }
        Toolbox.snVideoCall.av_buttons_status.camera = this.is_camera_on ? "on" : "off";
      } catch (e) {
        console.error(e);
        SNModal.alert(camera_not_available_msg);
      } finally {
        this.is_camera_processing = false;
      }
    },
    onMicrophoneBtnClick: async function () {
      if (!this.is_initialized || this.is_microphone_processing) {
        return;
      }

      if (!this.is_microphone_on) {
        const is_continue = await this.prepareDeviceBtnClick('microphone');
        if (!is_continue) {
          return;
        }
      }

      this.is_microphone_processing = true;

      try {
        if (this.is_microphone_on) {
          this.turnOffMicrophone();
        } else {
          await this.turnOnMicrophone(this.current_microphone_id, this.is_cancellation_on);
        }
        Toolbox.snVideoCall.av_buttons_status.microphone = this.is_microphone_on ? "on" : "off";
      } catch (e) {
        console.error(e);
        SNModal.alert('Your microphone is currently not available. It might be in use by another application. Close all other audio-based applications and then try turning on your microphone again.');
      } finally {
        this.is_microphone_processing = false;
      }
    },
  }
};

export const ScreenshareButton = function (nid) {
  console.log('ScreenshareButton init', {nid});
  if (Drupal.settings.is_broadcast_request) {
    console.warn("is broadcast request page");
    return;
  }

  console.log('ScreenshareButton init2', this);

  return {
    async init() {
      if (Toolbox.util.browser.is_mobile_device || typeof navigator?.mediaDevices?.getDisplayMedia !== 'function') {
        this.$el.style.display = 'none';
        return;
      }
      const {type, presenter, status} = Toolbox.snVideoCall?.current_presentation_status ?? {};
      this.presenter = presenter;
      this.presentationType = type;
      this.isPresentationOn = status === 'started';
      this.$el.innerHTML = `
<a class="screenshareButton toolbarButton round-btn video-icon " data-container="fullscreenElement"
 :class="isScreenshareOn ? 'screenshareOff' : 'screenshareOn'" x-bind:title="tooltip"
 @click.prevent.stop.throttle="onClick"
 >
  <i class="action-icon-fa" :class="isScreenshareOn ? 'fa-solid fa-stop' : 'fa-light fa-display' "></i>
</a>
`;
      document.addEventListener('participants-presentation-changed', (e) => {
        console.log('participants-presentation-changed', e);
        const {type, presenter, status} = e.detail;
        this.presenter = presenter;
        this.presentationType = type;
        if (['started', 'ended'].includes(status)) {
          this.isPresentationOn = status === 'started' && ['slides', 'video', 'screenshare'].includes(type);
          this.isScreenshareOn = status === 'started' && "screenshare" === type && presenter === Toolbox.twilio.current_user.toLowerCase();
        }
      });

      document.addEventListener('SnVideoRoomViewAttached', (e) => {
        console.log('SnVideoRoomViewAttached', e);
        const {nid} = e.detail;
        if (nid === 0 || nid === this.nid) {
          this.is_initialized = true;
        }
      });
    },

    nid: nid,
    is_initialized: false,
    isProcessing: false,
    presenter: "",
    presentationType: "",
    isPresentationOn: false,
    isScreenshareOn: false,
    mediaStream: null,
    videoTrack: null,
    audioTrack: null,
    get tooltip() {
      const s = this.isScreenshareOn ? 'Stop' : 'Start';
      return `${s} sharing screen or application`;
    },

    stopScreenSharing: async function () {
      Toolbox.snVideoCall.screenshare_local_track?.stop();
      let ret = null;
      if (this.audioTrack) {
        this.audioTrack.stop();
        Toolbox.snVideoCall.activeRoom.localParticipant.unpublishTrack(this.audioTrack);
      }
      if (this.videoTrack) {
        this.videoTrack.stop();
        ret = Toolbox.snVideoCall.activeRoom.localParticipant.unpublishTrack(this.videoTrack);
      }
      if (this.mediaStream) {
        this.mediaStream.getTracks().forEach(track => track.stop());
        this.mediaStream = null;
      }
      return ret;
    },
    startScreenSharing: async function () {
      let ret = null;
      if (!navigator.getDisplayMedia && !navigator.mediaDevices.getDisplayMedia) {
        throw new Error('Your browser does NOT supports getDisplayMedia API.');
      }
      const getDisplayOptions = {
        video: {
          height: 1080,
          width: 1920,
        },
        audio: {
          echoCancellation: true,
          noiseSuppression: true,
          sampleRate: 44100
        }
      }
      const mediaStream = await navigator.mediaDevices.getDisplayMedia(getDisplayOptions);
      this.mediaStream = mediaStream;
      const videoTracks = mediaStream.getVideoTracks();
      if (videoTracks.length > 0) {
        const videoTrack = videoTracks[0];
        this.videoTrack = videoTrack;
        const localTrack = new Twilio.Video.LocalVideoTrack(videoTrack, {name: 'video-composer-presentation'});
        Toolbox.snVideoCall.screenshare_local_track = localTrack;
        localTrack.once('stopped', () => {
          // Handle "stopped" event.
          console.log('Screen Sharing Stopped');
          this.stopScreenSharing();
        });
        ret = Toolbox.snVideoCall.activeRoom.localParticipant.publishTrack(localTrack, {priority: 'high'});
      }
      const audioTracks = mediaStream.getAudioTracks();
      if (audioTracks.length > 0) {
        const audioTrack = audioTracks[0];
        this.audioTrack = audioTrack;
        const localTrack = new Twilio.Video.LocalAudioTrack(audioTrack, {name: 'audio-composer-presentation'});
        Toolbox.snVideoCall.activeRoom.localParticipant.publishTrack(localTrack, {priority: 'high'});
      }

      return ret;
    },
    async onClick() {
      tippy.hideAll({duration: 0});
      close_action_menu(null, true);
      if (this.isProcessing || !this.is_initialized || !Toolbox.snVideoCall?.activeRoom?.localParticipant) {
        return;
      }
      this.isProcessing = true;

      if (this.isPresentationOn && !this.isScreenshareOn) {
        Toolbox.twilio.getUserInfo(this.presenter, _current_expoid(), (u) => {
          const msg = this.presenter === Toolbox.twilio.current_user.toLowerCase() ?
            'You are currently sharing your presentation. Please stop the presentation before sharing your screen.'
            : `${u.fullname} is currently sharing. Please wait until the user has stopped sharing before attempting to share.`;
          SNModal.alert(msg);
        });
        this.isProcessing = false;
        return false;
      }

      if (this.isScreenshareOn) {
        try {
          await this.stopScreenSharing();
        } catch (e) {
          console.error(e);
        } finally {
          this.isProcessing = false;
        }
        if (typeof Toolbox.snVideoCall == 'object') {
          Toolbox.snVideoCall.toggleSlideDeck(true);
          Toolbox.snVideoCall.enableDisabledLayout();
        }
        this.isScreenshareOn = false;
      } else {
        try {
          const v = await this.startScreenSharing()
          if (v) {
            Toolbox.snVideoCall.toggleSlideDeck(false);
            Toolbox.snVideoCall.enableDisabledLayout();
            this.isScreenshareOn = true;
          }
        } catch (e) {
          console.error(e);
          if (e.name === 'NotAllowedError') {
            SNModal.alert('Your operating system prevented you from sharing your screen. Review your privacy settings for your operating system and try again.');
          } else {
            SNModal.alert(e.message);
          }
          if (this.videoTrack) {
            this.videoTrack.stop();
          }
          if (this.audioTrack) {
            this.audioTrack.stop();
          }
        } finally {
          this.isProcessing = false;
        }
      }

      this.isProcessing = false;
    }
  }
};